import { fetcher } from "../../utils/fetcher.js";

export const globalSearch = (query, userId, limit = 50) => {
  const params = [];
  if (query) params.push(`q=${encodeURIComponent(query)}`);
  if (userId) params.push(`userId=${userId}`);
  if (limit) params.push(`limit=${limit}`);

  const queryString = params.length ? `?${params.join("&")}` : "";
  return fetcher.get(`/api/search${queryString}`);
};
